export const DEFAULT_ASSISTANT_PREFERENCES = {
  language: "English",
};

export const DEFAULT_ASSISTANT_UI_SETTINGS = {
  preferences: DEFAULT_ASSISTANT_PREFERENCES,
};
